import React, {useState, useEffect} from "react";
import "./Icon.scss";
import SVG from "react-inlinesvg";

export default function 
Icon({ icon, size, color, stroke, height }) {

  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    setHidden(true)
    setTimeout(() => {
      setHidden(false)
    }, 1)
  },[ color, stroke])

  function replaceColors(code, color, stroke){
    if(stroke && color){
      return code.replace(/stroke=".*?"/g, `stroke="${stroke}"`).replace(/fill=".*?"/g, `fill="${color}"`)
    }
    if(color){
      return code.replace(/fill=".*?"/g, `fill="${color}"`)
    }
    if(stroke){
      return code.replace(/stroke=".*?"/g, `stroke="${stroke}"`)
    }
  }

  return (
    <div className="c-icon">
      {!hidden && <SVG src={"/icons/" + (icon ? icon : "arrow") + ".svg"} width={size ? size : 22} height={height ? height : 20}  cacheRequests={true} preProcessor={(code) => (color || stroke ? replaceColors(code,color, stroke) : code)} /> }
    </div>
  );
}
